<form [formGroup]="form">

  <label id="metodo-de-pesquisa">Método de pesquisa:</label>

  <mat-radio-group aria-labelledby="metodo-de-pesquisa" class="radio-group"
    formControlName="filterMethod">
    <mat-radio-button class="radio-button" value="Nome">
      Nome
    </mat-radio-button>
    <mat-radio-button class="radio-button" value="Documento">
      CNPJ/CPF
    </mat-radio-button>
    <mat-radio-button class="radio-button" value="Ie">
      Inscrição Estadual
    </mat-radio-button>
    <mat-radio-button class="radio-button" value="Scp">
      Código SCP
    </mat-radio-button>
  </mat-radio-group>


  <mat-form-field class="full-width">
    <mat-label>Empresa</mat-label>
    <input type="text" matInput [matAutocomplete]="auto" formControlName="clientsControl">

    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
      <mat-option *ngFor="let option of clients$ | async" [value]="option">
        {{displayFn(option)}}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>

  <div class="inline-button-group -left">
    <button class="o-button -blue" [disabled]="disableAction" [ngClass]="{'generic-disabled': disableAction}"
      (click)="exportOrImport()">
      {{btnText}}
    </button>
  </div>
</form>
